import React from 'react';
import {
  Attachment,
  MessageText,
  MessageTimestamp,
  MessageActions,
  useMessageContext,
  MessageInput,
  isMessageEdited,
} from 'stream-chat-react';
import { useTranslation } from 'react-i18next';
import { Thumbnail, P } from 'design-system-web';
import cx from 'classnames';

import styles from './Message.module.scss';
import './getStreamOverrides.scss';
import { EditCommentBox } from '../commentBox/EditCommentBox';

export const Message = () => {
  const { message, groupStyles, editing, clearEditingState } =
    useMessageContext();
  const groupStyle = groupStyles?.[0] || 'middle';
  const { t } = useTranslation();

  if (editing) {
    return (
      <>
        <hr
          className={
            groupStyle === 'top' ? styles.separatorTop : styles.separatorMiddle
          }
        />
        <div className={styles.messageWrapper} data-testid="message-wrapper">
          <MessageInput
            hideSendButton
            clearEditingState={clearEditingState}
            Input={EditCommentBox}
          />
        </div>
      </>
    );
  }

  const isEdited = isMessageEdited(message);

  return (
    <>
      <hr
        className={
          groupStyle === 'top' ? styles.separatorTop : styles.separatorMiddle
        }
      />
      <div className={styles.messageWrapper} data-testid="message-wrapper">
        <Thumbnail name={message?.user?.name || ''} />
        <div className={styles.messageBody}>
          <div className={styles.messageHeader}>
            <div>
              <span className="font-bold mr-1" data-testid="commented-by">
                {message.user?.name}
              </span>
              <P data-testid="commented">
                {t('shared.workOrder.comments.message.commented')}
                {isEdited && (
                  <span
                    className={styles.messageEdited}
                    title={message.message_text_updated_at}
                    data-testid="message-edited"
                  >
                    {t('shared.workOrder.comments.message.edited')}
                  </span>
                )}
              </P>
            </div>
            <span className={styles.messageTimestamp} data-testid="timestamp">
              <MessageTimestamp />
            </span>
            {!message.deleted_at && (
              <MessageActions customWrapperClass={styles.messageActions} />
            )}
            
          </div>

          <div 
          
            className={cx(styles.messageContent, { italic: message.deleted_at })}
          >
          <MessageText
            message={message}
            renderText={() =>
              message.deleted_at
                ? t('shared.workOrder.comments.message.deleted')
                : message.text
            } 
          />
            { !message.deleted_at && message.attachments && (
              <Attachment attachments={message.attachments} />
            )}

          </div>
        </div>
      </div>
    </>
  );
};
